<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>护航全运，使命在肩--东进公司以专业消杀为体育梦想撑起“安全伞”</h2>
        <div id="meta_content">
          <span class="rich_b"> 东进防控 </span>
          <span id="rich_c">
            <span>2025-11-11 17:18</span>
            广东
          </span>
        </div>
        <img style="margin-top: 20px;" width="100%" :src="img[0]" alt="" />
        <p>
          近日，东进公司依托专业的综合环境治理能力，成功承接第十五届全运会东莞篮球中心及石龙中学体育馆的消杀保障任务。作为赛事期间东莞市唯一承担赛场内外全面消杀工作的病媒防制企业，公司将全力以赴，以扎实的防疫措施为在莞赛事筑牢安全屏障，用实际行动诠释“国企品质”，为十五全运会的顺利举办保驾护航。
        </p>
        <img width="100%" :src="img[1]" alt="" />

        <h3 style="font-weight: 700; font-size: 16px; color: #000">
          一、重任在肩：定制专业方案，守护赛场每一寸安全
        </h3>
        <p>
          体育赛场，是荣耀与拼搏交汇之地。东进公司深知，这里的每一寸场地不仅需要基础的清洁消杀，更呼唤专业化、系统化的环境治理，以保障赛事安全、致敬体育精神。
        </p>
        <p>
          在本次保障任务中，东进团队展现出卓越的执行力与专业性：所有操作人员均持证上岗，严格执行标准化作业流程，选用药剂均符合国家安全环保标准，结合先进消杀设备，实现空间立体化、全覆盖式处理，不留死角，全力营造安心、洁净的赛事环境。
        </p>
        <img width="100%" :src="img[2]" alt="" />

        <img width="100%" :src="img[3]" alt="" />

        <h3 style="font-weight: 700; font-size: 16px; color: #000">
          二、专业执行：细节之处彰显担当
        </h3>
        <p>
          从篮球馆内的激情呐喊，到举重馆中的力量迸发，每一处核心场馆的环境安全，不仅关系到赛事能否顺利推进，更直接影响到运动员的健康状态与观众的现场体验。
        </p>
        <p>
          东进团队将定制化方案精准落地于每一处细节：从药剂的科学配比到设备的规范操作，从高频接触面的重点处理到隐蔽区域的彻底排查，每一个环节都严谨把控、细致入微，确保体育精神在安全、健康的环境中熠熠生。
        </p>
        <img width="100%" :src="img[4]" alt="" />

        <h3 style="font-weight: 700; font-size: 16px; color: #000">
          三、护航盛会：专业服务赢得信赖，责任书写使命
        </h3>
        <p>
          此次承担全运会场馆消杀保障任务，是东进公司综合实力的生动体现。公司以专业技术护航体育盛事，以责任担当守护赛场平安。
        </p>
        <p>
          展望未来，东进公司将继续秉持高度的社会责任感，持续提升技术实力与服务等级，为城市各类重大活动提供坚实保障，为公共环境安全治理贡献更多力量。全运同行，健康相伴。东进公司预祝第十五届全运会圆满成功！
        </p>
        <img width="100%" :src="img[5]" alt="" />
        <h3>我们还提供多元化服务</h3>
        <img width="100%" :src="img[6]" alt="" />
        <h3>扫码关注我们了解更多</h3>
        <div>
          <img :src="img[7]" alt="" />
        </div>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span>&nbsp;</span>
        </el-col>
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
          style="text-align: right"
          class="hidden-xs-only"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'News17' })"
            >全力打造低空场景之城｜破解行业痛点...&nbsp;&nbsp;&nbsp;&nbsp;下一条
            &gt;</span
          >
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img: [
        require("@/assets/news18_1.jpg"),
        require("@/assets/news18_2.jpg"),
        require("@/assets/news18_3.jpg"),
        require("@/assets/news18_4.jpg"),
        require("@/assets/news18_5.jpg"),
        require("@/assets/news18_6.jpg"),
        require("@/assets/news8-4.png"),
        require("@/assets/news8-7.png"),
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.black {
  font-weight: 700;
}

.kongxi {
  height: 10px;
}

.big-div {
  display: flex;
  justify-content: space-evenly;
}

.small-div {
  text-align: center;
}

.small-div1 img {
  width: 258px;
  height: 258px;
}

.small-div2 img {
  width: auto;
  height: auto;
}

.caption {
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.content {
  width: 90%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  h3 {
    font-weight: normal;
    font-family: 黑体, SimHei;
    font-size: 18px;
    margin: 20px 0;
    text-align: left;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }
}

.wenzi {
  margin: 0 !important;
  color: rgb(255, 255, 255) !important;
}

@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      margin: 20px 0;
      text-align: center;
      font-size: 24px;
    }

    h3 {
      font-size: 18px;
      margin: 20px 0;
      text-align: left;
    }

    p {
      margin: 10px 0;
      text-align: justify;
      text-indent: 2em;
      font-size: 16px;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}

#meta_content {
  font-size: 15px;
  padding-left: 2.6em;

  span {
    color: rgba(0, 0, 0, 0.3);
  }

  .rich_b {
    color: #576b95 !important;
  }
}
</style>
